import { render, staticRenderFns } from "./Identicon.vue?vue&type=template&id=45a26547&"
import script from "./Identicon.vue?vue&type=script&lang=js&"
export * from "./Identicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports